/**
 * Checks if code is running on client or server side by looking if window is defined or not.
 *
 * @returns - True if the code is running on the client side and flase if running on the server side.
 */
const isClient = () => typeof window !== 'undefined';
export default isClient;
//# sourceMappingURL=isClient.js.map